// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {BulkUploadModalModuleLayout} from 'app_components/modules/admin/bulkUploadModal'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import BulkUploadService from 'app_services/admin/bulkUpload/bulkUploadService'
// @end

// @import types
import {IBulkUploadModalHeader, IBulkUploadEndpoint} from 'app_types/admin/bulkUploadModal/bulkUploadModalTypes'
// @end

// @ADD Component types
interface IBulkUploadModalModuleProps {
  open       : boolean
  handleClose: (data:any) => void
  header?    : IBulkUploadModalHeader
  helperFile?: string
  endpoint   : IBulkUploadEndpoint
  showErrors?: boolean
}
interface IBulkUploadModalModuleState {
  processing: boolean
  errors: Array<any>
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BulkUploadModalModule extends Component<IBulkUploadModalModuleProps, IBulkUploadModalModuleState> {

  private bulkUploadService: BulkUploadService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBulkUploadModalModuleProps) {
    super(props)
    this.state = {
      processing: false,
      errors: []
    }

    this.bulkUploadService = new BulkUploadService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onHandleSubmit = async (data: any) => {
    this.setState({processing: true})

    const response = await this.bulkUploadService.uploadFile(
      data,
      this.props.endpoint
    )

    if (response.code === 200) {
      // let screen_notification_label = 'modules.bulk_upload_modal.upload_success'

      // this.screenNotifications.fireToast(
      //   {
      //     message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
      //   },
      //   {
      //     position: 'bottom-right',
      //   }
      // )

      this.setState({processing: false})
      this.props.handleClose({status: true, response})

    } else {
      if (this.props.showErrors) {
        if (response?.errors?.length) {
          await this.screenNotifications
          .fire(
            {
              message: `${this.i18nUtil.getTranslate('components.screen_notifications.warnings.records_with_errors', {
                successfully: `${response.total_created}`,
                errors: `${response.errors.length}`,
              })}`,
            },
            {
              type: 'warning',
              title: `${this.i18nUtil.getTranslate('components.screen_notifications.errors.error_entering_records')}`,
              confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText_details')}`,
              cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText_continue')}`,
              showCancelButton: true,
            },
          )?.then(async (result) => {
            if (result.value) {
              this.setState({errors: response.errors})
            } else {
              this.setState({processing: false})
              this.props.handleClose({status: false})
            }
          })
        } else {
          this.screenNotifications.fire(response)

          this.setState({processing: false})

          this.props.handleClose({status: true, response})
        }
      } else {
        this.screenNotifications.fire(response)

        this.setState({processing: false})
        this.props.handleClose({status: false})
      }
    }
  }

  render() {
    return(
      <BulkUploadModalModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        onHandleSubmit={this.onHandleSubmit}
        processing={this.state.processing}
        header={this.props.header}
        helperFile={this.props.helperFile}
        errors={this.state.errors}
      />
    )
  }
}

export default connect(mapStatesToProps)(BulkUploadModalModule)
